import { useSearchParams } from "react-router-dom";

import { useGetQueryParams } from "#modules/quoteRequestLines/infra/useGetQueryParams";
import { FilterQuery } from "shared";

export const useHandleSetFilterParams = ({
  setFiltersParams,
}: {
  setFiltersParams: (filters: FilterQuery) => void;
}) => {
  const [, setSearchParams] = useSearchParams();

  const DEFAULT_COLUMNS_COUNT = "3";

  const { columns } = useGetQueryParams({
    params: ["filters", "columns"],
  });

  const handleSetFilterParams = (filters: FilterQuery) => {
    setFiltersParams(filters);

    setSearchParams({
      filters: encodeURIComponent(JSON.stringify(filters)),
      columns: columns ?? DEFAULT_COLUMNS_COUNT,
    });
  };

  return { handleSetFilterParams, DEFAULT_COLUMNS_COUNT };
};
